import React from "react";
import "../../Styles/commonfooter.css";

const TermsandConditons = () => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <div className="main-app-contianer">
      <div className="features-dropdown-bAnner-section">
        <div className="width-wrapper">
          <div className="wrap-1" data-aos="zoom-in-down">
            <h1>Terms & Conditions</h1>
            <p>
              Welcome to Ann. By accessing or using our website and services,
              you agree to the following terms and conditions:
            </p>
          </div>
        </div>
      </div>

      <div className="wrap-card">
        <div className="width-wrapper">
          <div className="row">
            <div className="card" data-aos="fade-right" data-aos-delay="200">
              <h2>1. Acceptance of Terms</h2>
              <p>
                By using Ann's platform, you accept and agree to be boundby
                these Terms. If you do not agree, you must not use ourservices.
              </p>
            </div>

            <div className="card" data-aos="fade-left" data-aos-delay="200">
              <h2>2. Use of Services</h2>
              <p>
                You agree to use the platform only for lawful purposes and in a
                way that does not infringe the rights of, restrict, or inhibit
                others from using Ann. Misuse of the system, including spamming
                or falsifying data, is prohibited.
              </p>
            </div>

            <div className="card" data-aos="fade-right" data-aos-delay="200">
              <h2>3. User Responsibilities</h2>
              <p>You are responsible for:</p>
              <ul>
                <li>
                  Ensuring the accuracy of all data and documents you submit.
                </li>
                <li>Maintaining confidentiality of your login credentials.</li>
                <li>
                  Complying with all applicable local, state, and international
                  laws.
                </li>
              </ul>
            </div>

            <div className="card" data-aos="fade-left" data-aos-delay="200">
              <h2>4. Employer and Job Seeker Content</h2>
              <p>
                You retain ownership of the content you provide, including
                resumes and job listings. By uploading or submitting content,
                you grant Ann a non-exclusive, royalty-free license to use,
                display, and distribute it for recruitment purposes.
              </p>
            </div>

            <div className="card" data-aos="fade-right" data-aos-delay="200">
              <h2>5. Intellectual Property</h2>
              <p>
                All content on the site (excluding user-submitted content),
                including text, software, logos, and design, is the property of
                Ann and protected by copyright and other intellectual property
                laws.
              </p>
            </div>

            <div className="card" data-aos="fade-left" data-aos-delay="200">
              <h2>6. Limitation of Liability</h2>
              <p>
                Ann provides services on an “as-is” basis. We make no guarantees
                regarding outcomes from using our platform. We are not liable
                for any direct, indirect, incidental, or consequential damages
                resulting from the use of our services.
              </p>
            </div>

            <div className="card" data-aos="fade-right" data-aos-delay="200">
              <h2>7. Modifications to Terms</h2>
              <p>
                We may revise these Terms at any time. Continued use of Ann
                after changes have been posted constitutes your acceptance of
                the new Terms.
              </p>
            </div>

            <div className="card" data-aos="fade-left" data-aos-delay="200">
              <h2>8. Termination</h2>
              <p>
                We reserve the right to suspend or terminate your access to the
                platform at our sole discretion, especially if you violate these
                Terms.
              </p>
            </div>

            <div className="card" data-aos="fade-right" data-aos-delay="200">
              <h2>9. Contact</h2>
              <p>
                For questions or concerns regarding these Terms, contact:
                <br />
                Email: support@Ann.ai
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsandConditons;
